export enum Paths {
  HOME = '/',
  LOGIN = '/login',

  DATA_DASHBOARD = '/data-dashboard',

  GOALS_DASHBOARD = '/goals-dashboard',

  PRODUCERS = '/producers',
  PRODUCER = '/producers/:slug',

  CONTRACTS = '/contracts',
  CONTRACT_CONSUMPTIONS = '/contracts/consumptions',

  MONTHLY_VOLUMES = '/monthly-volumes',

  FEEDBACK_WIDGETS = '/feedback-widgets',
  FEEDBACK_WIDGETS_DETAIL = '/feedback-widgets/:id',

  ARCHIVED_EMAILS = '/archived-emails',
  CREDIT_CHECKS = '/credit-checks',
  USERS = '/users',
  PASSWORD_RESET = '/password-reset',

  INTERNAL_USERS = '/internal-users',
  CREATE_INTERNAL_USER = '/internal-users/create',
  EDIT_INTERNAL_USER = '/internal-users/:id/edit',

  SALES_BULK_CSV_UPLOAD = '/sales/bulk-csv-upload',

  SALES_EVENTS = '/sales/events',
  CREATE_SALES_EVENT = '/sales/events/create',
  EDIT_SALES_EVENT = '/sales/events/:id/edit',

  SALES_PARAMETERS = '/sales/parameters',
  CREATE_SALES_PARAMETER = '/sales/parameters/create',
  EDIT_SALES_PARAMETER = '/sales/parameters/:id/edit',

  SALES_USERS = '/sales/users',
  CREATE_SALES_USER = '/sales/users/create',
  EDIT_SALES_USER = '/sales/users/:id/edit',

  EVENTLOG = '/eventlog'
}
